import clsx from 'clsx';

import styles from './UserAvatar.module.scss';

export enum DesignSystemUserAvatarSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  EXTRA_LARGE = 'extra_large',
}

type GetAvatarClassesOptions = {
  size?: DesignSystemUserAvatarSize;
  hasImage?: boolean;
  className?: string;
};

export const getAvatarInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (!parts.length) {
    return '?';
  }

  if (parts.length === 1) {
    return Array.from(parts[0]).slice(0, 2).join('').toUpperCase();
  }

  return `${Array.from(parts[0])[0]}${
    Array.from(parts[parts.length - 1])[0]
  }`.toUpperCase();
};

export const getAvatarClasses = ({
  size = DesignSystemUserAvatarSize.MEDIUM,
  hasImage,
  className,
}: GetAvatarClassesOptions): string => {
  return clsx(
    styles.avatar,
    styles[size],
    {
      [styles.has_image]: hasImage,
    },
    className,
  );
};
